import React, { useState, useEffect } from 'react'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import defaultTexts from '../../../texts/texts'
import { capitalizeFirstLetter } from '../../_common/_helpers/string'
import { checkAccessRequest } from '../../../_network/request'

const OpenStackServicesViewRegion = (props) => {
  const {
    service,
    config_params,
    service_domain,
    service_version,
    is_identity_provider,
    region_name,
    resource_suspend_policy,
    resource_suspend_period,
    resource_delete_policy,
    resource_delete_period,
    billingServices,
    showBillingFields,
  } = props
  const theme = useTheme()

  const [domainAccess, setDomainAccess] = useState(defaultTexts.addSubscriptionResponsePlaceholder)
  const [serviceDomain, setServiceDomain] = useState('')
  const [apiVersion, setApiVersion] = useState('')
  const [isIdentityProvider, setIsIdentityProvider] = useState(false)
  const [regionName, setRegionName] = useState('')
  const [suspendAction, setSuspendAction] = useState('')
  const [suspendDelay, setSuspendDelay] = useState('')
  const [finalAction, setFinalAction] = useState('')
  const [finalActionDelay, setFinalActionDelay] = useState('')

  const keySmStyle = {
    color: theme.palette.vodka,
    fontSize: '18px',
    fontWeight: '500',
    marginBottom: '5px',
  }

  const valueSmStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '18px',
    fontWeight: '500',
    marginBottom: '20px',
  }

  const checkAccessButtonStyle = {
    fontWeight: '400',
    color: 'white',
    background: theme.palette.greenSheen,
    fontSize: '18px',
    height: '44px',
    borderRadius: '22px',
    padding: '0px 40px',

    '&:hover': {
      background: alpha(theme.palette.greenSheen, 0.8),
    },
  }

  const responseTextStyle = {
    background: theme.palette.aliceBlue,
    color: theme.palette.oxfordBlue,
    fontSize: '18px',
    fontWeight: '500',
    borderRadius: '20px',
    padding: '20px',
  }

  const handleCheckAccess = async () => {
    setDomainAccess('loading...')

    const response = await checkAccessRequest(serviceDomain)    
    
    if (response && response.data) {
      setDomainAccess(response.data)
    } else {
      setDomainAccess(defaultTexts.anErrorOccured)
    }
  }

  useEffect(() => {
    const getBillingConfigValue = (service_name, region_name, field_key) => {
      const service_object = billingServices.find(item => item.service_name === service_name && item.region_name === region_name)
      return (service_object && service_object[field_key]) ? service_object[field_key] : ''
    }

    if (config_params && config_params.service_domain) {
      const region_name = config_params.region_name ? config_params.region_name : config_params.default_region

      setServiceDomain(config_params.service_domain)
      setApiVersion(capitalizeFirstLetter(config_params.api_version))
      setIsIdentityProvider(config_params.is_identity_provider)
      setRegionName(region_name)
      setSuspendAction(capitalizeFirstLetter(getBillingConfigValue(service, region_name, 'resource_suspend_policy')))
      setSuspendDelay(getBillingConfigValue(service, region_name, 'resource_suspend_period'))
      setFinalAction(capitalizeFirstLetter(getBillingConfigValue(service, region_name, 'resource_delete_policy')))
      setFinalActionDelay(getBillingConfigValue(service, region_name, 'resource_delete_period'))
    } else if (service_domain) {
      setServiceDomain(service_domain)
      setApiVersion(capitalizeFirstLetter(service_version))
      setIsIdentityProvider(is_identity_provider)
      setRegionName(region_name)
      setSuspendAction(capitalizeFirstLetter(resource_suspend_policy))
      setSuspendDelay(resource_suspend_period)
      setFinalAction(capitalizeFirstLetter(resource_delete_policy))
      setFinalActionDelay(resource_delete_period)
    }
  }, [
    service,
    config_params,
    service_domain,
    service_version,
    is_identity_provider,
    region_name,
    resource_suspend_policy,
    resource_suspend_period,
    resource_delete_policy,
    resource_delete_period,
    billingServices,
  ])
  
  return (
    <>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, lg: 6 }}>
          
          <Box sx={keySmStyle}>{defaultTexts.serviceDomain}</Box>
          <Box sx={valueSmStyle}>{serviceDomain}</Box>

          <Box sx={keySmStyle}>{defaultTexts.apiVersion}</Box>
          <Box sx={valueSmStyle}>{apiVersion}</Box>

          <Box sx={keySmStyle}>{defaultTexts.isIdentityProvider}</Box>
          <Box sx={valueSmStyle}>{ isIdentityProvider ? defaultTexts.yes : defaultTexts.no }</Box>

          <Box sx={keySmStyle}>{ isIdentityProvider ? defaultTexts.defaultRegion : defaultTexts.regionName}</Box>
          <Box sx={valueSmStyle}>{regionName}</Box>

          {
            isIdentityProvider &&
            <>
              <Box sx={keySmStyle}>{defaultTexts.credentialsProvided}</Box>
              <Box sx={valueSmStyle}>{defaultTexts.yes}</Box>
            </>
          }

        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>

          {
            showBillingFields &&
            <>
              <Box sx={keySmStyle}>{defaultTexts.suspendAction}</Box>
              <Box sx={valueSmStyle}>{suspendAction}</Box>

              <Box sx={keySmStyle}>{defaultTexts.suspendDelayMinutes}</Box>
              <Box sx={valueSmStyle}>{suspendDelay}</Box>

              <Box sx={keySmStyle}>{defaultTexts.finalAction}</Box>
              <Box sx={valueSmStyle}>{finalAction}</Box>

              <Box sx={keySmStyle}>{defaultTexts.finalActionDelayMinutes}</Box>
              <Box sx={valueSmStyle}>{finalActionDelay}</Box>
            </>
          }          

        </Grid>
      </Grid>

      <Stack
        direction='row'
        justifyContent='flex-end'
        sx={{ margin: '20px 0px' }}
      >
        <Button
          variant='text'
          disableRipple
          disableElevation
          disabled={false}
          onClick={handleCheckAccess}
          sx={checkAccessButtonStyle}
        >
          {defaultTexts.checkAccess}
        </Button>
      </Stack>
      <Box sx={responseTextStyle}>
        <pre>
          { domainAccess ? JSON.stringify(domainAccess, null, 2) : defaultTexts.anErrorOccured }
        </pre>
      </Box>
    </>
  )
}

export default OpenStackServicesViewRegion